import { render, staticRenderFns } from "./Stage.vue?vue&type=template&id=bdb10ce4&scoped=true&"
import script from "./Stage.vue?vue&type=script&lang=js&"
export * from "./Stage.vue?vue&type=script&lang=js&"
import style0 from "./Stage.vue?vue&type=style&index=0&id=bdb10ce4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdb10ce4",
  null
  
)

export default component.exports